<script setup lang="ts">
definePageMeta({
    hidePromotions: true,
})

const { site } = useCoreConfig()
const { data: pageData } = await usePageData('faq')

const { data: faqSections } = await useFaqData()

const searchQuery = ref('')

// SEO
const { getHead, getSeoMeta } = useStrapiSeo(
    pageData.value?.seo || {
        metaTitle: `Ofte stillede spørgsmål - ${site.name}`,
        metaDescription: 'Før du kontakter os med dit spørgsmål, bedes du læse disse ofte stillede spørgsmål igennem. Der er en god chance for, at dit spørgsmål er besvaret her.'
    }
)

useHead(getHead())
useSeoMeta(getSeoMeta())
// ./ SEO
</script>

<template>
    <section class="faq">
        <div class="faq-header-wrapper">
            <div class="faq__header">
                <h1 class="faq__title">
                    Ofte stillede spørgsmål
                </h1>

                <div class="faq__subtitle">
                    Har du problemer eller spørgsmål, så find hjælp her.
                </div>
            </div>

            <div class="faq-search-wrapper">
                <div class="faq__notice">
                    Før du
                    <NuxtLink :to="{ name: 'kundeservice' }">
                        kontakter os
                    </NuxtLink>
                    med dit spørgsmål,
                    bedes du læse disse ofte stillede spørgsmål igennem.
                    Der er en god chance for, at dit spørgsmål er besvaret her.
                </div>

                <UIInput
                    v-model="searchQuery"
                    name="search"
                    type="input"
                >
                    Søg efter spørgsmål
                </UIInput>
            </div>
        </div>

        <!-- We'll take the first instance, since we need to extend the faq-collection Strapi controller to take a "seoName" or "type" -->
        <!-- Right now it simply finds all of the collections and returns them in an array -->
        <NimbusStrapiFaq
            :sections="faqSections"
            :search-query="searchQuery"
            :show-section-title="true"
        >
            <template #emptySections>
                <div>
                    Vores ofte stillede spørgsmål er på nuværende tidspunkt ikke tilgængelig.
                    <NuxtLink :to="{ name: 'kundeservice' }">
                        Kontakt vores kundeservice.
                    </NuxtLink>
                </div>
            </template>

            <template #emptySearch>
                <div>
                    Søgningen gav ingen resultat.
                    Prøv igen, eller
                    <NuxtLink :to="{ name: 'kundeservice' }">
                        kontakt vores kundeservice.
                    </NuxtLink>
                </div>
            </template>
        </NimbusStrapiFaq>
    </section>
</template>

<style lang="scss" scoped>
.faq {
    display: grid;
    gap: 40px;

    &__title {
        font-size: 30px;
        font-weight: 700;
    }

    &__subtitle {
        font-size: 24px;
    }

    &__search {
        width: 100%;
    }
}

.faq-header-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.faq-search-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
